import {BaseView} from '../core/view';
import { TrackingUtil } from '../utils/tracking';
import {JSErrorTracking} from '../utils/js-error-tracking';
import { MobileUtil } from '../utils/mobile';
import {BrowserSupport} from "../utils/browser-support"

export default BaseView.extend({

    el: '.js-search-block',
    slider: undefined,

    events: {
        'click .js-vertical-post': 'onClickMagazinePostPreview',
        'contextmenu .js-product-preview': 'onRightClickTrack'
    },

    initialize: function () {
        if (this.$el.length){
            const posts = document.querySelectorAll('.js-vertical-post');
            for(const post of Array.from(posts)) {
                TrackingUtil.throwGAEvent('Magazine Post Impression', post.getAttribute('data-post-slug'), window.location.pathname, true);
            }
            if (JSErrorTracking.isEnabled && !BrowserSupport.isIE()) {
                const images = document.querySelectorAll('.product-preview__image');
                for(const img of Array.from(images)) {
                    img.onerror = this.logImageLoadFailure;
                }
            }
        }
    },
    
    onRightClickTrack: (e) => {
        TrackingUtil.throwGAEvent('TrackRightClick', 'clicked', '', false);
    },

    onClickMagazinePostPreview: function (e) {
        TrackingUtil.throwGAEvent('Magazine Post Clicked', e.currentTarget.getAttribute('data-post-slug'), window.location.pathname, false);
    },

    logImageLoadFailure: function(e) {
        JSErrorTracking.sendCustomError("Failed to load product image " + e.currentTarget.src);
    }
});
